export default __webpack_public_path__ + "static/skin-69a0d54982d757f750201285537ac8d4.png";